import { Protocol } from '../Protocol';

export class MaterialStatusProportion {
  public static readonly GET_ALL_MATERIAL_STATUS: string = `${Protocol.YATUNG_API_ROOT}/materialStatus/all`;
}
